import { NotificationHelper } from "../util/notificationHelper.js";
import { Helper } from "../util/helper.js";
import { Config } from "../config/config.js";
import { Dialog, DialogAction, DialogProps } from "./dialog.js";
import { HTTPService, createHtppServiceInstance, JsonResultClass } from "../util/httpManager.js";
import { FullHeightContainer } from "./FullHeighContainer.js";
import { ComponentHelper } from "../util/componentHelper.js";
import { FieldInstance } from "./field.js";
import { DropDownList } from "./dropDownList.js";
import { Language } from "../../reportMetaData/reportMetaDataHelper.js";
import { TextBox } from "./textBox.js";
import { CheckBox } from "./checkBox.js";
import { FAIcon } from "./faIcon.js";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";

export class PrintQrHelper {
    public static getTargetEntityType = (key: string): TargetEntityType => {
        const dict = {
            "servicereport": TargetEntityType.ServiceReport,
            "1": TargetEntityType.ServiceReport,
            "weeklyreport": TargetEntityType.WeeklyReport,
            "2": TargetEntityType.WeeklyReport,
            "crreport": TargetEntityType.CustomReport,
            "customreport": TargetEntityType.CustomReport,
            "3": TargetEntityType.CustomReport,
            "assignment": TargetEntityType.Assignment,
            "resourceplanning": TargetEntityType.Assignment,
            "4": TargetEntityType.Assignment,
            "machine": TargetEntityType.Machine,
            "david": TargetEntityType.Machine,
            "5": TargetEntityType.Machine,
            "resource": TargetEntityType.Resource,
            "6": TargetEntityType.Resource,
            "ticket": TargetEntityType.Ticket,
            "7": TargetEntityType.Ticket,
            "address": TargetEntityType.Address,
            "8": TargetEntityType.Address,
            "parts": TargetEntityType.Material,
            "material": TargetEntityType.Material,
            "9": TargetEntityType.Material,
            "project": TargetEntityType.Project,
            "10": TargetEntityType.Project
        };
        return dict[key.toLowerCase()];
    }

    public static getId = (obj: {}): string => {
        const check = (value: string) => {
            return !Helper.isNullOrEmpty(value) && PrintQrHelper.isGuid(result.toLowerCase());
        }
        const possibleKeys = ["isguid", "id", "servicereportid"];
        let result: string = null;
        for (let i = 0; i < possibleKeys.length; i++) {
            result = Helper.getAttributeSavely(obj, possibleKeys[i]);
            if (check(result)) {
                return result;
            }
        }
        return null;
    }

    private static isGuid = (value) => {
        var regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
        var match = regex.exec(value);
        return match != null;
    }

    public static openDialog = (targetEntityType: TargetEntityType, id: string, getDefaultName: (reportName: string) => string) => {
        const targetElement = $("<div>");
        $("body").append(targetElement);
        const props: PrintQrReportDialogProps = {
            onClose: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            },
            onPrint: () => {
            },
            targetEntityType: targetEntityType,
            id: id,
            getDefaultName: getDefaultName
        }
        const dialog = <><PrintQrReportDialog {...props} /></>
        ReactDOM.render(dialog, targetElement[0]);
    }

    public static awaitPdf = (jobId: number): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {

            let intervalTokken: number = null;
            const destroy = () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
                window.clearInterval(intervalTokken);
            }

            const dialogProps: DialogProps = {
                title: "",
                actions: [
                    {
                        label: Config.translations.ok,
                        action: destroy,
                        primary: true
                    }
                ]
            };
            const targetElement = $("<div>");
            $("body").append(targetElement);
            ReactDOM.render(
                <Dialog {...dialogProps} open={true} title={Config.translations.createReport}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <FAIcon name="spinner" spins={true} attributes={["spin", "2x"]} style={{ color: "var( --primary-color)" }} />
                    </div>
                </Dialog >, targetElement[0]);


            let continue_download = true;
            let counter = 0;
            intervalTokken = window.setInterval(async () => {
                if (continue_download) {
                    const errorCode = -1;
                    const finished = 0;
                    const waitForPrinting = 1;
                    const isPrinting = 2;
                    const axiosResult = await axios.get<JsonResultClass<number>>(Config.baseUrl + "AtlasQrReportPrint/CheckFileState?jobId=" + jobId)
                    const result = axiosResult.data;
                    if (result.Code == 0) {
                        switch (result.Data) {
                            case errorCode:
                                continue_download = false;
                                destroy();
                                reject(result.AdditionalData["errors"]);
                                break;
                            case finished:
                                continue_download = false;
                                Helper.openInNewBrowserTab(`${Config.baseUrl}AtlasQrReportPrint/DownloadReport?jobId=${jobId}`);
                                destroy();
                                resolve(true);
                                break;
                            default:
                            case isPrinting:
                            case waitForPrinting:
                                continue_download = true;
                                break;
                        }
                    } else {
                        continue_download = false;
                        destroy();
                        reject([result.Message]);
                    }


                    counter += 1;
                    if (counter > Config.settings.printJobPollingTimeInSeconds) {
                        continue_download = false;
                        destroy();
                        resolve(false);
                    }

                }
            }, 1000);
        });
    }
}

class PrintQrReportDialog extends React.Component<PrintQrReportDialogProps, PrintQrReportDialogState> {
    private translations: StringKeyDictionary<string>;
    private reports: ReportSelection[];
    private languages: Language[];
    private languageCode: string;
    private loaded: boolean;
    private factory = ComponentHelper.createFactory();
    private dialogProps: DialogProps;
    private isMainOffice: boolean;
    private dialogRef: Dialog;

    constructor(props: PrintQrReportDialogProps) {
        super(props)
        this.loaded = false;
        this.state = {
            selectedReport: null,
            language: null,
            dialogOpen: true,
            fileName: "",
            generateDocument: false,
            documentTitle: "",
            documentRemark: "",
            isMainOfficeOnly: false,
            waitForCreation: false
        };
        this.initApp();
    }

    private closeDialog = () => {
        if (Helper.hasValue(this.dialogRef))
            this.dialogRef.close();
        this.props.onClose();
    }

    private getDefaultFileName = (report: ReportSelection = null) => {
        if (!Helper.hasValue(report))
            report = this.state.selectedReport
        const fileName = report?.FileName;
        if (Helper.isNullOrEmpty(fileName)) {
            if (!Helper.hasValue(report))
                report = this.state.selectedReport;

            const name = this.props.getDefaultName(report.Name);
            return {
                fileName: name + '.pdf',
                documentTitle: name
            }
        }
        return {
            fileName: report.FileName,
            documentTitle: report.OptionalDocumentTitle
        }

    }

    private setReport = (report: ReportSelection) => {
        let { fileName, documentTitle } = this.getDefaultFileName(report);
        let languages: string[] = Helper.mergeLists([this.languageCode], Helper.getBrowserLanguages(), report.Files[0].Key);
        let language = "";
        for (let i = 0; i < languages.length; i++) {
            if (this.kenodObjToList(report.Files).findIndex(f => f.Key === languages[i]) > -1) {
                language = languages[i];
                break;
            }
        }
        this.setState({
            fileName: fileName,
            language: language,
            selectedReport: report,
            documentTitle: documentTitle,
            generateDocument: true
        })
    }

    private kenodObjToList = (obj) => {
        let lst = []
        Object.keys(obj).filter(f => Helper.isNumber(f)).forEach((key) => {
            lst.push(obj[key]);
        });
        return lst;
    }

    private initApp = async () => {
        Promise.all([
            this.getTranslations(),
            HTTPService.get<JsonResultClass<ReportSelection[]>>(`AtlasQrReportPrint/GetReports?targetEntityType=${this.props.targetEntityType}&id=${this.props.id}`),
            this.getLanguages()
        ]).then((results) => {
            if (Helper.hasValue(results[0]) && results[1].Code === 0) {
                this.translations = results[0];
                this.reports = results[1].Data;
                this.languages = results[2];
                this.languageCode = results[1].AdditionalData["languageCode"];
                this.isMainOffice = results[1].AdditionalData["isMainOffice"];
                this.loaded = true;
                this.setDialogProps();
                if (this.reports.length > 0) {
                    this.setReport(this.reports[0]);
                } else {
                    this.setState({})
                }
            } else {
                if (!Helper.hasValue(results[0])) {
                    NotificationHelper.showErrorMessage("Could not load translations");
                }
                if (results[1].Code > 0) {
                    NotificationHelper.showErrorMessage(results[1].Message);
                }
                this.closeDialog();
            }
        });
    }

    private getTranslations = (): Promise<StringKeyDictionary<string>> => {
        return new Promise<StringKeyDictionary<string>>(async (resolve) => {
            const translationsKeys = [
                "WebSMS.ReportMetadata.NoReportsCouldBeFound",
                "Standard.Continue",
                "Standard.Drucken",
                "Standard.BackBtn",
                "Standard.Name",
                "Parts.TranslationLink.LabelLanguage",
                "WebSMS.QRReports.FileName",
                "Dokument.DocumentTitle",
                "Field.BelegMaterial.bemerkung",
                "Dokument.GenerateDocument",
                "Dokument.OnlyMainOffice",
                "WebSMS.ReportMetadata.WaitForCreation"
            ];
            let result = await Helper.getTranslations(translationsKeys);
            resolve(result.Data)
        });
    }

    private getLanguages = (): Promise<Language[]> => {
        return new Promise<Language[]>(async (resolve) => {
            let result = await HTTPService.get<JsonResultClass<Language[]>>("EditIndividualFields/GetLanguages")
            resolve(result.Data);
        });
    }

    private setDialogProps = () => {
        let actions: DialogAction[] = [];
        if (this.reports.length > 0) {
            actions.push({
                label: Config.translations.cancel,
                action: () => {

                }
            });
        }
        actions.push({
            label: this.reports.length === 0 ? Config.translations.ok : this.translations["Standard.Drucken"],
            action: this.reports.length === 0 ? () => { } : this.print,
            primary: true
        });
        this.dialogProps = {
            title: Config.translations.select,
            afterClose: () => {
                this.closeDialog();
            },
            actions: actions
        };
    }

    private print = () => {
        const options = {
            TargetEntityType: this.props.targetEntityType,
            Id: this.props.id,
            ReportId: this.state.selectedReport.Id,
            LanguageCode: this.state.language,
            FileName: this.state.fileName,
            GenerateDocument: this.state.generateDocument,
            DocumentTitle: this.state.documentTitle,
            DocumentRemark: this.state.documentRemark,
            IsMainOfficeOnly: this.state.isMainOfficeOnly
        }
        HTTPService.post<JsonResultClass<number>>("AtlasQrReportPrint/Print", { options: options }).then((result) => {
            this.closeDialog();
            switch (result.Code) {
                case 0:
                    if (this.state.waitForCreation) {
                        this.waitForCreation(result.Data);
                    }
                    break;
                case 1:
                    NotificationHelper.showErrorMessage(result.Message);
                    break;
            }
        });
    }

    private waitForCreation = async (jobId: number) => {
        try {
            return await PrintQrHelper.awaitPdf(jobId);
        } catch (e) {
            const errors: string[] = e;
            errors.forEach(msg => NotificationHelper.showErrorMessage(msg))
        }
    }

    private createDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps} width={(this.reports.length > 0) ? 1000 : 500} open={true} ref={(ref) => { this.dialogRef = ref }}>
                    <FullHeightContainer>
                        {this.createBody()}
                    </FullHeightContainer>
                </Dialog>
            </>
        );
    }

    private createBody = () => {
        if (this.reports.length > 0) {
            return (
                <div style={{ display: "flex" }}>
                    <div style={{ width: "48.5%", marginRight: "1.5%" }}>
                        {this.createFileDropDown()}
                        {this.createLanguageDropDown()}
                        {this.createFileNameTextBox()}
                        {this.createWaitCheckBox()}
                    </div>
                    <div style={{ width: "48.5%", marginLeft: "1.5%" }}>
                        {this.generateDocumentCheckBox()}
                        {this.createDocumentTitleTextBox()}
                        {this.createDocumentRemarkTextBox()}
                        {this.isMainOffice ? this.createIsMainOfficeOnlyCheckBox() : null}
                    </div>
                </div>
            );
        } else {
            return (
                <>
                    <label>
                        {this.translations["WebSMS.ReportMetadata.NoReportsCouldBeFound"]}
                    </label>
                </>
            );
        }
    }

    private createFileDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.value = this.state.selectedReport.Id;
        props.dataSource = this.reports;
        props.onChange = (field, value, dataItem) => {
            this.setReport(dataItem)
        };
        props.field.dataTextField = "Name";
        props.field.dataValueField = "Id";
        props.field.optionLabel = "";
        props.field.refreshDSOnRefChange = true;
        return (
            <FieldInstance label={this.translations["Standard.Name"]}>
                <DropDownList {...props} />
            </FieldInstance>

        );
    }

    private createLanguageDropDown = () => {
        let props = this.factory.getDefaultDropDownProps();
        props.value = this.state.language;
        props.dataSource = this.mapToLanguageDataSource(this.state.selectedReport.Files);
        props.onChange = (field, value) => {
            this.setState({ language: value })
        };
        props.field.dataTextField = "text";
        props.field.dataValueField = "value";
        props.field.template = "<table cellspacing='0' style='table-layout:fixed; width:300px'><colgroup><col style='width: 150px' /><col style='width: 150px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.text}</td><td style='vertical-align:top'>${data.file}</td></tr></table>"
        props.field.optionLabel = "";
        props.field.refreshDSOnRefChange = true;
        return (
            <FieldInstance label={this.translations["Parts.TranslationLink.LabelLanguage"]}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private mapToLanguageDataSource = (lst: KeyValuePair<string, string>[]) => {
        let lang: Language;
        let arr: string[];
        let result = lst.map((item) => {
            lang = this.languages.find(l => l.Code === item.Key);
            if (Helper.hasValue(lang)) {
                arr = item.Value.split("\\");
                return {
                    value: item.Key,
                    text: lang.Displaynameen + " (" + lang.Displaynamenative + ")",
                    file: arr.length > 0 ? arr.pop() : ""
                };
            } else {
                return null;
            }
        }).filter(f => Helper.hasValue(f));
        return result;
    }

    private createFileNameTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.fileName;
        props.onChange = (field, value: string) => {
            if (Helper.isNullOrEmpty(value)) {
                value = `${this.getDefaultFileName()}.pdf`;
            }
            if (!value.match(".*\.pdf$")) {
                value += ".pdf";
            }
            this.setState({ fileName: value })
        };
        return (
            <FieldInstance label={this.translations["WebSMS.QRReports.FileName"]}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private createWaitCheckBox = () => {
        let props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.waitForCreation;
        props.onChange = (field, value) => {
            this.setState({ waitForCreation: value })
        }
        return (
            <FieldInstance label={this.translations["WebSMS.ReportMetadata.WaitForCreation"]} labelStyle={{ width: "fit-content" }}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    private generateDocumentCheckBox = () => {
        let props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.generateDocument;
        props.onChange = (field, value) => {
            this.setState({ generateDocument: value })
        }
        return (
            <FieldInstance label={this.translations["Dokument.GenerateDocument"]} labelStyle={{ width: "fit-content" }}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    private createDocumentTitleTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.documentTitle;
        props.disabled = !this.state.generateDocument;
        props.onChange = (_, value: string) => {
            if (Helper.isNullOrEmpty(value)) {
                value = this.state.documentTitle;
            }
            this.setState({ documentTitle: value })
        }
        return (
            <FieldInstance label={this.translations["Dokument.DocumentTitle"]}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private createDocumentRemarkTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.disabled = !this.state.generateDocument;
        props.value = this.state.documentRemark;
        props.onChange = (_, value: string) => {
            this.setState({ documentRemark: value })
        };
        props.field.multiLine = true;
        props.field.textAreaHeight = "60px"
        return (
            <FieldInstance label={this.translations["Field.BelegMaterial.bemerkung"]}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private createIsMainOfficeOnlyCheckBox = () => {
        let props = this.factory.getDefaultCheckBoxProps();
        props.disabled = !this.state.generateDocument;
        props.value = this.state.isMainOfficeOnly;
        props.onChange = (field, value) => {
            this.setState({ isMainOfficeOnly: value })
        }
        return (
            <FieldInstance label={this.translations["Dokument.OnlyMainOffice"]} labelStyle={{ width: "fit-content" }}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    render() {
        const dialog = (this.loaded && this.state.dialogOpen) ? this.createDialog() : null;
        return (
            <>
                {dialog}
            </>
        );
    }
}

interface PrintQrReportDialogProps {
    onClose: () => void;
    onPrint: () => void;
    getDefaultName: (reportName: string) => string
    targetEntityType: TargetEntityType;
    id: string;
}

interface PrintQrReportDialogState {
    selectedReport: ReportSelection;
    language: string;
    dialogOpen: boolean;
    fileName: string;
    waitForCreation: boolean;
    generateDocument: boolean;
    documentTitle: string;
    documentRemark: string;
    isMainOfficeOnly: boolean;
}

interface ReportSelection {
    Id: number;
    Name: string;
    Files: KeyValuePair<string, string>[];
    GenerateDocument: boolean;
    OptionalDocumentTitle: string;
    FileName: string;

}

export enum TargetEntityType {
    ServiceReport = 1,
    WeeklyReport = 2,
    CustomReport = 3,
    Assignment = 4,
    Machine = 5,
    Resource = 6,
    Ticket = 7,
    Address = 8,
    Material = 9,
    Project = 10
}